// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.fireblocks",
    name: "Fireblocks",
    homepage: "https://www.fireblocks.com/",
    image_id: "7e1514ba-932d-415d-1bdb-bccb6c2cbc00",
    app: {
        browser: "https://console.fireblocks.io/",
        ios: "https://apps.apple.com/us/app/fireblocks/id1439296596",
        android: "https://play.google.com/store/apps/details?id=com.fireblocks.client&gl=IL",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "fireblocks-wc://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: "https://console.fireblocks.io/v2/",
    },
};
//# sourceMappingURL=index.js.map